import { FC } from 'react';

import { capitalizeString } from '@abg/web-core/common/utils/helpers';

import { useTranslationContext } from '../../../../shared/context';
import { AncillariesI18nKeys } from '../../../../shared/types';
import { RateTermItem } from '../RateTermItem';
import { normalizeInfoMinMaxHelper } from '../RateTermsNotes/normalize-info-min-max.helper';

import { RateTermInfoItemProps } from './rate-term-info-item.types';

export const RateTermInfoItem: FC<RateTermInfoItemProps> = ({
  rateTerms,
  isInfoMax = false,
}) => {
  const { t, i18nKeys } = useTranslationContext<AncillariesI18nKeys>();
  const { minRequiredDays, minRequiredHours, maxAllowedDays, maxAllowedHours } =
    rateTerms || {};

  const safeMinRequiredDays = minRequiredDays ?? 0;
  const safeMinRequiredHours = minRequiredHours ?? 0;
  const safeMaxAllowedDays = maxAllowedDays ?? 0;
  const safeMaxAllowedHours = maxAllowedHours ?? 0;

  const minDaysLabel =
    safeMinRequiredDays > 1 ? t(i18nKeys.days) : t(i18nKeys.day);
  const minHoursLabel =
    safeMinRequiredHours > 1 ? t(i18nKeys.hours) : t(i18nKeys.hour);
  const maxDaysLabel =
    safeMaxAllowedDays > 1 ? t(i18nKeys.days) : t(i18nKeys.day);
  const maxHoursLabel =
    safeMaxAllowedHours > 1 ? t(i18nKeys.hours) : t(i18nKeys.hour);

  const normalizePlaceholder = normalizeInfoMinMaxHelper(rateTerms);

  const infoMaxPlaceholder = {
    ...normalizePlaceholder('maxAllowedDays', capitalizeString(maxDaysLabel)),
    ...normalizePlaceholder('maxAllowedHours', maxHoursLabel),
  };

  const infoMinPlaceholder = {
    ...normalizePlaceholder('minRequiredDays', capitalizeString(minDaysLabel)),
    ...normalizePlaceholder('minRequiredHours', minHoursLabel),
  };

  const infoPlaceholder = isInfoMax ? infoMaxPlaceholder : infoMinPlaceholder;
  const infoLabel = isInfoMax
    ? i18nKeys.rateTermsInfoMax
    : i18nKeys.rateTermsInfoMin;

  if (isInfoMax && !maxAllowedDays && !maxAllowedHours) return null;
  if (!isInfoMax && !minRequiredDays && !minRequiredHours) return null;

  return <RateTermItem>{t(infoLabel, infoPlaceholder)}</RateTermItem>;
};
